var _style, _g, _g2, _g3, _g4, _g5, _g6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOcelotDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2_00000040549958189925264140000016966537234904481712_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 920 267.8",
    style: {
      enableBackground: "new 0 0 920 267.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#40AF65;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.9,78.3c32.8,0,52.8,23.9,52.8,55c0,31.3-19.9,55.2-52.8,55.2c-33,0-52.9-23.9-52.9-55.2 C268.9,102.1,288.9,78.3,321.9,78.3z M321.9,171.5c22.2,0,33.2-15.5,33.2-38.2c0-22.5-10.9-38-33.2-38s-33.3,15.5-33.3,38 C288.6,156,299.7,171.5,321.9,171.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.3,78.3c29,0,48.1,16.4,51.2,42.9h-19.6c-2.4-16.7-14.3-25.9-31.3-25.9c-21.3,0-33.8,14.4-33.8,38 c0,23.7,12.5,38.2,33.8,38.2c17,0,28.9-9.3,31.3-26h19.6c-3.2,26.6-22.2,43-51.2,43c-33,0-53.1-23.9-53.1-55.2 C387.2,102.1,407.3,78.3,440.3,78.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M506.8,79.8h72.5v17h-52.9v28h45.3v17h-45.3V170h52.9v17h-72.5V79.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M594.5,177.3V79.8h19.6v91.7L667,170v17l-61,1.5C598.8,188.7,594.5,184.6,594.5,177.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M707.8,78.3c32.8,0,52.8,23.9,52.8,55c0,31.3-19.9,55.2-52.8,55.2c-33,0-52.9-23.9-52.9-55.2 C654.9,102.1,674.8,78.3,707.8,78.3z M707.8,171.5c22.2,0,33.2-15.5,33.2-38.2c0-22.5-10.9-38-33.2-38s-33.3,15.5-33.3,38 C674.5,156,685.6,171.5,707.8,171.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M865.6,96.8h-35.7V187h-19.6V96.8h-36v-17h91.4V96.8z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "103.8,158.9 77.5,158.9 77.5,153.9 96.5,153.9 88.1,131.5 104.1,90 129.1,90 129.1,95.1  107.6,95.1 93.5,131.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "94.9,114.6 85.5,94.8 85.5,66.3 101.8,66.3 129.9,90.8 126.6,94.7 99.9,71.4 90.6,71.4 90.6,93.7  99.5,112.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "133.1,187.8 117.4,187.8 104.1,170.3 83.5,170.3 83.5,165.2 106.6,165.2 119.9,182.7 129.9,182.7  132.9,176.8 123,166.5 126.7,163 139,175.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "161.5,169.6 142,150.6 150.8,131.3 141.1,95.1 129.7,95.1 120.1,131.3 128.9,150.6 108.5,169.4  105.1,165.6 122.7,149.4 114.7,131.7 125.8,90 145,90 156.1,131.7 148.1,149.4 165.1,165.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "193.9,158.9 167,158.9 177.4,131.5 163.3,95.1 141.8,95.1 141.8,90 166.8,90 182.8,131.5  174.4,153.9 193.9,153.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "176.5,115.2 171.8,113.2 180.2,93.7 180.2,71.4 170.9,71.4 145,94.6 141.6,90.9 169,66.3  185.3,66.3 185.3,94.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "153.4,187.8 137.8,187.8 131.9,175.9 144.2,163 147.9,166.5 138,176.8 140.9,182.7 150.9,182.7  164.3,165.2 188.4,165.2 188.4,170.3 166.8,170.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 98.6,
    y: 128.9,
    className: "st2",
    width: 18.9,
    height: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.4,
    y: 128.9,
    className: "st2",
    width: 18.9,
    height: 5.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 111.7,
    y: 129.3,
    transform: "matrix(0.837 -0.5473 0.5473 0.837 -59.4724 85.8047)",
    className: "st2",
    width: 5.1,
    height: 26.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 140.2,
    transform: "matrix(0.5474 -0.8369 0.8369 0.5474 -48.6287 195.5267)",
    className: "st2",
    width: 26.8,
    height: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.9,
    y: 122.6,
    className: "st2",
    width: 5.1,
    height: 15.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 126.4,
    className: "st2",
    width: 5.1,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.8,
    y: 126.4,
    className: "st2",
    width: 5.1,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.9,
    y: 111.6,
    className: "st2",
    width: 5.1,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.9,
    y: 141.2,
    className: "st2",
    width: 5.1,
    height: 8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M141.2,214.5h-11.6l-4.9-16.1c-27.2-4.5-48.8-26.1-53.3-53.3l-16.1-4.9v-11.6l16.1-4.9 c1.9-11.4,6.8-22,14.2-31l3.9,3.3c-7.2,8.6-11.8,19-13.4,30l-0.2,1.6l-15.6,4.7v4.1l15.6,4.7l0.2,1.6c3.7,26.2,24.6,47.2,50.8,50.8 l1.6,0.2l4.7,15.6h4.1l4.7-15.6l1.6-0.2c26.2-3.7,47.2-24.6,50.8-50.8l0.2-1.6l15.6-4.7v-4.1l-15.6-4.7l-0.2-1.6 c-1.6-11.3-6.4-21.8-13.8-30.5l3.9-3.3c7.7,9,12.8,19.9,14.7,31.5l16.1,4.9v11.6l-16.1,4.9c-4.5,27.2-26.1,48.8-53.3,53.3 L141.2,214.5L141.2,214.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M159.9,79.8c-5.1-2.3-10.5-3.8-16.1-4.6l-1.6-0.2l-4.7-15.6h-4.1L128.6,75l-1.6,0.2 c-5.3,0.8-10.6,2.2-15.5,4.4l-2-4.7c4.8-2.1,10-3.6,15.2-4.5l4.9-16.1h11.6l4.9,16.1c5.5,0.9,10.8,2.5,15.8,4.8L159.9,79.8 L159.9,79.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.4,73.8l-2.2-4.6c7.7-3.7,16-6,24.6-6.8l0.5,5.1C121.3,68.2,113.6,70.3,106.4,73.8L106.4,73.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.5,128.3l-5-0.5c1.6-17.3,9.4-33.5,22-45.6l3.5,3.7C77.2,97.1,69.9,112.2,68.5,128.3L68.5,128.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128.8,206.4c-34.8-3.1-62.3-30.7-65.4-65.4l5.1-0.5c2.9,32.3,28.5,57.9,60.8,60.8L128.8,206.4L128.8,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M142,206.4l-0.5-5.1c32.3-2.9,57.9-28.5,60.8-60.8l5.1,0.5C204.3,175.8,176.8,203.3,142,206.4L142,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M202.4,128.3c-1.5-16.6-9.1-31.9-21.3-43.2l3.4-3.7c13.2,12.2,21.3,28.7,22.9,46.5L202.4,128.3L202.4,128.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M165.4,74.2c-7.2-3.6-15-5.8-23.1-6.7l0.5-5c8.7,0.9,17,3.3,24.8,7.2L165.4,74.2L165.4,74.2z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcelotDark);
export default __webpack_public_path__ + "static/media/OCELOT-dark.1bd79317b0b069e830c57df2fa379446.svg";
export { ForwardRef as ReactComponent };